import {
  type SeriesPropsWithAxes,
  type XYChartDataWithCorrespondingSeries,
} from '../types/xy-chart-internals.js';
import type { XYChartData } from '../types/xy-chart.js';

/**
 * Combines root data with corresponding series that have axes information.
 *
 * @param rootData - The root data for the chart.
 * @param seriesWithAxes - The series with their corresponding axes properties.
 * @returns - An array of combined data with corresponding series.
 */
export function combineDataWithCorrespondingSeries(
  rootData: XYChartData[],
  seriesWithAxes: SeriesPropsWithAxes[],
): XYChartDataWithCorrespondingSeries[] {
  const combinedData: XYChartDataWithCorrespondingSeries[] = [
    {
      data: rootData,
      series: [],
    },
  ];
  const ROOT_DATA_POSITION = 0;

  for (const series of seriesWithAxes) {
    const { seriesProps } = series;

    if (seriesProps.data) {
      combinedData.push({
        data: seriesProps.data,
        series: [{ ...series }],
      });
    } else {
      combinedData[ROOT_DATA_POSITION].series.push({ ...series });
    }
  }

  return combinedData;
}
